import { confirmDialog } from "primereact/confirmdialog";

export const useResetSCVDialog = () => {
    const confirmResetSCVDialog = ({ message, header, accept }) => {
        confirmDialog({
            header,
            message,
            icon: "pi pi-exclamation-triangle",
            acceptLabel: "Reset",
            acceptIcon: "pi pi-refresh",
            rejectLabel: "Hủy",
            rejectIcon: "pi pi-times",
            acceptClassName: "p-button-warning",
            rejectClassName: "p-button-secondary p-button-outlined",
            accept,
        });
    };
    return { confirmResetSCVDialog };
};